import axios from 'axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

const instance = axios.create()

function toFormData(data) {
  var fd = new FormData()
  for (var key in data) {
    fd.append(key, data[key])
  }
  return fd
}

const multipart = { 'Content-Type': 'multipart/form-data' }

const servicesAPI = {

  // CATEGORIA DE COMPRA
  agregarCategoriaCompra(data) {
    var url = ConfigAPI.baseURL + 'purchase-category' + Session.getToken()
    return instance.post(url, data)
  },
  obtenerCategoriaCompra(id) {
    var url = ConfigAPI.baseURL + 'purchase-category/' + id + Session.getToken()
    return instance.get(url)
  },
  editarCategoriaCompra(data) {
    var url = ConfigAPI.baseURL + 'purchase-category/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // CLIENTES
  obtenerCliente(id) {
    var url = ConfigAPI.baseURL + 'customers/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarCliente(data) {
    var url = ConfigAPI.baseURL + 'customers' + Session.getToken()
    return instance.post(url, toFormData(data), { headers: multipart })
  },
  editarCliente(data) {
    var url = ConfigAPI.baseURL + 'customers/' + data.id + Session.getToken()
    return instance.post(url, toFormData(data), { headers: multipart })
  },
  obtenerFiscalConditions() {
    var url = ConfigAPI.baseURL + 'sales-fiscal-conditions' + Session.getToken()
    return instance.get(url)
  },
  obtenerTypesDocuments() {
    var url = ConfigAPI.baseURL + 'sales-types-documents' + Session.getToken()
    return instance.get(url)
  },
  agregarSalesCustomers(data) {
    var url = ConfigAPI.baseURL + 'sales-customers' + Session.getToken()
    return instance.post(url, data)
  },
  editarSalesCustomers(data) {
    var url = ConfigAPI.baseURL + 'sales-customers/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // PROVEEDORES
  obtenerProveedor(id) {
    var url = ConfigAPI.baseURL + 'suppliers/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarProveedor(data) {
    var url = ConfigAPI.baseURL + 'suppliers' + Session.getToken()
    return instance.post(url, toFormData(data), { headers: multipart })
  },
  editarProveedor(data) {
    var url = ConfigAPI.baseURL + 'suppliers/' + data.id + Session.getToken()
    return instance.post(url, toFormData(data), { headers: multipart })
  },
  agregarSalesSuppliers(data) {
    var url = ConfigAPI.baseURL + 'sales-suppliers' + Session.getToken()
    return instance.post(url, data)
  },
  editarSalesSuppliers(data) {
    var url = ConfigAPI.baseURL + 'sales-suppliers/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // PRODUCTOS - LINEAS
  obtenerLineas() {
    var url = ConfigAPI.baseURL + 'products-line' + Session.getToken()
    return instance.get(url)
  },
  obtenerLinea(id) {
    var url = ConfigAPI.baseURL + 'products-line/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarLinea(data) {
    var url = ConfigAPI.baseURL + 'products-line' + Session.getToken()
    return instance.post(url, data)
  },
  editarLinea(data) {
    var url = ConfigAPI.baseURL + 'products-line/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // PRODUCTOS - SUBLINEAS
  obtenerSublinea(id) {
    var url = ConfigAPI.baseURL + 'products-subline/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarSublinea(data) {
    var url = ConfigAPI.baseURL + 'products-subline' + Session.getToken()
    return instance.post(url, data)
  },
  editarSublinea(data) {
    var url = ConfigAPI.baseURL + 'products-subline/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // PRODUCTOS - CATEGORIAS
  obtenerCategorias() {
    var url = ConfigAPI.baseURL + 'products-category' + Session.getToken()
    return instance.get(url)
  },
  obtenerCategoria(id) {
    var url = ConfigAPI.baseURL + 'products-category/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarCategoria(data) {
    var url = ConfigAPI.baseURL + 'products-category' + Session.getToken()
    return instance.post(url, toFormData(data), { headers: multipart })
  },
  editarCategoria(data) {
    var url = ConfigAPI.baseURL + 'products-category/' + data.id + Session.getToken()
    return instance.post(url, toFormData(data), { headers: multipart })
  },

  // PRODUCTOS - SUBCATEGORIAS
  obtenerSubcategoria(id) {
    var url = ConfigAPI.baseURL + 'products-subcategory/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarSubcategoria(data) {
    var url = ConfigAPI.baseURL + 'products-subcategory' + Session.getToken()
    return instance.post(url, data)
  },
  editarSubcategoria(data) {
    var url = ConfigAPI.baseURL + 'products-subcategory/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // PRODUCTOS - COLORES
  obtenerColor(id) {
    var url = ConfigAPI.baseURL + 'products-colors/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarColor(data) {
    var url = ConfigAPI.baseURL + 'products-colors' + Session.getToken()
    return instance.post(url, data)
  },
  editarColor(data) {
    var url = ConfigAPI.baseURL + 'products-colors/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // PRODUCTOS - TALLES
  obtenerTalle(id) {
    var url = ConfigAPI.baseURL + 'products-waist/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarTalle(data) {
    var url = ConfigAPI.baseURL + 'products-waist' + Session.getToken()
    return instance.post(url, data)
  },
  editarTalle(data) {
    var url = ConfigAPI.baseURL + 'products-waist/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // EMPLEADOS - CATEGORIAS
  obtenerCategoriaEmpleado(id) {
    var url = ConfigAPI.baseURL + 'employee/category/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarCategoriaEmpleado(data) {
    var url = ConfigAPI.baseURL + 'employee/category' + Session.getToken()
    return instance.post(url, data)
  },
  editarCategoriaEmpleado(data) {
    var url = ConfigAPI.baseURL + 'employee/category/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // LISTAS GENERALES
  obtenerListaClientes() {
    var url = ConfigAPI.baseURL + 'customers' + Session.getToken()
    return instance.get(url)
  },
  obtenerListaEmpleados() {
    var url = ConfigAPI.baseURL + 'employee/employee' + Session.getToken()
    return instance.get(url)
  },

  // PROYECTOS
  obtenerProyecto(id) {
    var url = ConfigAPI.baseURL + 'projects/projects/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarProyecto(data) {
    var url = ConfigAPI.baseURL + 'projects/projects' + Session.getToken()
    return instance.post(url, data)
  },
  editarProyecto(data) {
    var url = ConfigAPI.baseURL + 'projects/projects/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // ACTIVIDADES
  obtenerActividad(id) {
    var url = ConfigAPI.baseURL + 'projects/activity/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarActividad(data) {
    var url = ConfigAPI.baseURL + 'projects/activity' + Session.getToken()
    return instance.post(url, data)
  },
  editarActividad(data) {
    var url = ConfigAPI.baseURL + 'projects/activity/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // MÉTODOS DE PAGO
  obtenerMetodoPago(id) {
    var url = ConfigAPI.baseURL + 'sales-methods-payment/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarMetodoPago(data) {
    var url = ConfigAPI.baseURL + 'sales-methods-payment' + Session.getToken()
    return instance.post(url, data)
  },
  editarMetodoPago(data) {
    var url = ConfigAPI.baseURL + 'sales-methods-payment/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // CATEGORIA DE SERVICIOS
  obtenerCategoriaServicio(id) {
    var url = ConfigAPI.baseURL + 'services-category/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarCategoriaServicio(data) {
    var url = ConfigAPI.baseURL + 'services-category' + Session.getToken()
    return instance.post(url, data)
  },
  editarCategoriaServicio(data) {
    var url = ConfigAPI.baseURL + 'services-category/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // IVA CONDITIONS
  obtenerCondicionesIVA() {
    var url = ConfigAPI.baseURL + 'sales-iva-conditions' + Session.getToken()
    return instance.get(url)
  },

  // CONCEPTOS
  obtenerConcepto(id) {
    var url = ConfigAPI.baseURL + 'sales-concepts/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarConcepto(data) {
    var url = ConfigAPI.baseURL + 'sales-concepts' + Session.getToken()
    return instance.post(url, data)
  },
  editarConcepto(data) {
    var url = ConfigAPI.baseURL + 'sales-concepts/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // MÉTODOS DE ACOPIO
  obtenerMetodoAcopio(id) {
    var url = ConfigAPI.baseURL + 'sales-methods-acopio/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarMetodoAcopio(data) {
    var url = ConfigAPI.baseURL + 'sales-methods-acopio' + Session.getToken()
    return instance.post(url, data)
  },
  editarMetodoAcopio(data) {
    var url = ConfigAPI.baseURL + 'sales-methods-acopio/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // MONEDAS
  obtenerMoneda(id) {
    var url = ConfigAPI.baseURL + 'price-currency/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarMoneda(data) {
    var url = ConfigAPI.baseURL + 'price-currency' + Session.getToken()
    return instance.post(url, data)
  },
  editarMoneda(data) {
    var url = ConfigAPI.baseURL + 'price-currency/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // ZONAS DE VENDEDORES
  obtenerVendedores() {
    var url = ConfigAPI.baseURL + 'sellers' + Session.getToken()
    return instance.get(url)
  },
  obtenerZona(id) {
    var url = ConfigAPI.baseURL + 'sellers-zone/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarZona(data) {
    var url = ConfigAPI.baseURL + 'sellers-zone' + Session.getToken()
    return instance.post(url, data)
  },
  editarZona(data) {
    var url = ConfigAPI.baseURL + 'sellers-zone/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

  // FORMAS DE PAGO COMPRAS
  obtenerInfoPayment(id) {
    var url = ConfigAPI.baseURL + 'purchase-infoPayment/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarInfoPayment(data) {
    var url = ConfigAPI.baseURL + 'purchase-infoPayment' + Session.getToken()
    return instance.post(url, data)
  },
  editarInfoPayment(data) {
    var url = ConfigAPI.baseURL + 'purchase-infoPayment/' + data.id + Session.getToken()
    return instance.post(url, data)
  },

}

export default servicesAPI
